import React, { useState, useEffect } from "react";
import "../styles/PointManagementPage.css";
import MyPageSidebar from "./MyPageSidebar";
import UserProfile from "./UserProfile";

const PointManagementPage = () => {
    const [myData, setMyData] = useState([]); // 사용자 데이터
    const [pointHistory, setPointHistory] = useState([]); // 포인트 내역
    const [filter, setFilter] = useState("전체"); // 적립 or 사용 필터
    const [selectedMonth, setSelectedMonth] = useState(""); // 개월 수 필터
    const [startDate, setStartDate] = useState(""); // 시작 날짜 필터
    const [endDate, setEndDate] = useState(""); // 종료 날짜 필터
    const [currentPage, setCurrentPage] = useState(1); // 페이지네이션
    const itemsPerPage = 5; // 한 페이지에 표시할 개수
    const [oneMonthAgo, setOneMonthAgo] = useState(""); // API 응답값 저장
    const [todayDate, setTodayDate] = useState(""); // API 응답값 저장

    // ✅ **포인트 내역 불러오기 (API 호출)**
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("/api/point");
                if (response.ok) {
                    const data = await response.json();
                    setPointHistory(data.pointData || []);
                    setOneMonthAgo(data.oneMonthAgo);
                    setTodayDate(data.todayDate);
                } else {
                    console.error("포인트 데이터를 가져오는데 실패했습니다.");
                }
            } catch (error) {
                console.error("API 요청 중 오류 발생:", error);
            }
        };

        fetchData();
    }, []);

    // ✅ **날짜 변환 함수**
    const parseDate = (dateStr) => {
        const [year, month, day] = dateStr.split(".").map(Number);
        return new Date(2000 + year, month - 1, day); // 25.03.19 → 2025-03-19 변환
    };

    // ✅ **개월 수 필터링**
    const filterByMonth = (data) => {
        try{
            if (!selectedMonth) return data;

            let fromDate = new Date(todayDate);
            if (selectedMonth === "1개월") fromDate.setMonth(fromDate.getMonth() - 1);
            if (selectedMonth === "3개월") fromDate.setMonth(fromDate.getMonth() - 3);
            if (selectedMonth === "6개월") fromDate.setMonth(fromDate.getMonth() - 6);

            return data.filter(item => parseDate(item.pointDate) >= fromDate);
        } catch (error) {
            return "noData";
        }

    };

    // ✅ **날짜 범위 필터링**
    const filterByDate = (data) => {
        try{
            if (!startDate || !endDate) return data;
            const fromDate = new Date(startDate);
            const toDate = new Date(endDate);

            return data.filter(item => {
                const itemDate = parseDate(item.pointDate);
                return itemDate >= fromDate && itemDate <= toDate;
            });
        } catch (error) {
            return "noData";
        }

    };

    // ✅ **적립 / 사용 필터링**
    const filterByType = (data) => {
        try{
            if (filter === "전체") return data;
            return data.filter(item => (filter === "적립" ? item.pointType === "SAVE" : item.pointType === "USE"));
        } catch (error) {
            return "noData";
        }

    };

    // ✅ **모든 필터 적용**
    let filteredData = filterByType(pointHistory);
    filteredData = filterByMonth(filteredData);
    filteredData = filterByDate(filteredData);

    // ✅ **페이지네이션 계산**
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = filteredData.slice(startIndex, startIndex + itemsPerPage);


    // ✅ **페이지 이동 함수**
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="point-container">
            <MyPageSidebar />
            <div className="point-content">
                <h2 className="mypage-title">MY 관리</h2>
                <UserProfile />

                <h2 className="point-title">포인트</h2>

                {/* ✅ 사용 가능 포인트 박스 */}
                <div className="point-box">
                    <div className="point-icon">P</div>
                    <div className="point-info">
                        <p className="point-text">사용가능한 포인트 <span className="point-amount">0P</span></p>
                        <p className="point-expiration">소멸예정 포인트 0P</p>
                    </div>
                </div>

                {/* ✅ 필터 옵션 */}
                <div className="point-filter">
                    <button className={`filter-btn ${filter === "전체" ? "active" : ""}`} onClick={() => setFilter("전체")}>전체</button>
                    <button className={`filter-btn ${filter === "적립" ? "active" : ""}`} onClick={() => setFilter("적립")}>적립</button>
                    <button className={`filter-btn ${filter === "사용" ? "active" : ""}`} onClick={() => setFilter("사용")}>사용</button>

                    <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                        <option value="">전체</option>
                        <option value="1개월">1개월</option>
                        <option value="3개월">3개월</option>
                        <option value="6개월">6개월</option>
                    </select>

                    <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                    <span> ~ </span>
                    <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>

                {/* ✅ 포인트 내역 테이블 */}
                <table className="point-table">
                    <thead>
                    <tr>
                        <th>적립일</th>
                        <th>구분</th>
                        <th>내용</th>
                        <th>포인트</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems !== "noDat" ? (
                        currentItems.map((item, index) => (
                            <tr key={index}>
                                <td>{item.pointDate}</td>
                                <td className={item.pointType === "SAVE" ? "point-earn" : "point-use"}>
                                    {item.pointType === "SAVE" ? "적립" : "사용"}
                                </td>
                                <td className="point-table-content">{item.description}</td>
                                <td className={item.pointType === "SAVE" ? "point-earn" : "point-use"}>
                                    {item.deltaPoint.toLocaleString()}P
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" className="no-data">포인트 내역이 없습니다.</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PointManagementPage;
